module.exports = __webpack_public_path__ + "static/img/8105_phase_function_Paper_PointsHejduk_Prediction.ad9fa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8105_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 46O/
// module chunks = 0